import { TableRow } from "@mui/material";
import { blue } from "@mui/material/colors";
import { FC } from "react";
import { useIntl } from "react-intl";

import { IInfoTrain } from "./index";
import { StyledTableCell } from "./styled";

export interface ITrainInfoTable {
  trainInfo: IInfoTrain;
  showTrain?: boolean;
  isOnlyPage?: boolean;
}

export const TrainInfoTable: FC<ITrainInfoTable> = props => {
  const { showTrain = true, trainInfo, isOnlyPage = false } = props;

  const { formatMessage } = useIntl();

  return (
    <>
      {Object.keys(trainInfo)
        .filter(key => key !== "points")
        .filter(key => !!(trainInfo as Record<string, any>)[key])
        .map((key, index) =>
          (trainInfo as Record<string, any>)[key] ? (
            <TableRow key={key} sx={{ backgroundColor: showTrain && index === 0 ? blue[200] : "inherit" }}>
              <StyledTableCell isOnlyPage={isOnlyPage}>
                {formatMessage({ id: `pages.journals.popup.train.${key}` })}
              </StyledTableCell>
              <StyledTableCell isOnlyPage={isOnlyPage}>{(trainInfo as Record<string, any>)[key]}</StyledTableCell>
            </TableRow>
          ) : null,
        )}
      {trainInfo.points.map(({ name, value }) => (
        <TableRow key={name}>
          <StyledTableCell isOnlyPage={isOnlyPage}>{name}</StyledTableCell>
          <StyledTableCell isOnlyPage={isOnlyPage}>{value}</StyledTableCell>
        </TableRow>
      ))}
    </>
  );
};
